import { NgModule } from '@angular/core';
import { CertemyCommonModule } from 'common/certemy-common.module';
import { FeeFormProfessionalComponent } from './fee-form-professional.component';
import { NumberInputModule, RadioGroupModule, RadioModule } from '@certemy/ui-components';

@NgModule({
  imports: [CertemyCommonModule, NumberInputModule, RadioModule, RadioGroupModule],
  exports: [FeeFormProfessionalComponent],
  declarations: [FeeFormProfessionalComponent],
})
export class FeeFormProfessionalModule {}
